import { LoadingOverlay } from '@talentmesh/core';
import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Navigate, Outlet } from 'react-router-dom';
import RoutePath from './RoutePath';
import { useUserContext } from '../Context/UserContext';

const ProtectedRoute = () => {
    const { user } = useUserContext();
    const { isAuthenticated, isLoading, loginWithRedirect } = useAuth0();

    useEffect(() => {
        if (isLoading || isAuthenticated) {
            return;
        }

        (async (): Promise<void> => {
            await loginWithRedirect({
                appState: {
                    returnTo: `${window.location.pathname}${window.location.search}`,
                },
            });
        })();
    }, [user, isLoading, isAuthenticated, loginWithRedirect]);

    if (!user) {
        return <Navigate to={RoutePath.Error} />;
    }

    return (
        // eslint-disable-next-line react/jsx-props-no-spreading
        isAuthenticated ? <Outlet /> : <LoadingOverlay />
    );
};

export default ProtectedRoute;
